module.exports = __webpack_public_path__ + "img/icon_footer_01.f13e508a.svg";